import { Button } from "@biteship/atom";
import { PlusCircleIcon } from "../../images/icons";
import FilterButton from "./filterButton";
import FilterDate from "./filterDate";
import TicketSection from "./ticketSection";
import Search from '@components/input/Search';
import ReactLoading from "react-loading";
import { useEffect, useState, useCallback } from "react";
import { debounce } from 'lodash';
// import { trackEvent } from "services/analytics";

export default function TicketListView(props) {
  const [search, setSearch] = useState('')
  const onChangeFilters = (key, value) => {
    const newFilters = { ...props.filters, [key]: value };
    props.setFilters(newFilters);
  };

  const onChangeDate = (startDate, endDate) => {
    if ((startDate, endDate)) {
      props.setFilters({
        ...props.filters,
        createdStartDate: startDate,
        createdEndDate: endDate,
      });
    }
  };

  const debounceSearch = useCallback(debounce(function (val) {
    onChangeFilters('search', val)
  }, 1000), []);

  return (
    <div className="relative w-full md:w-1/2 lg:w-1/3 bg-white border-r border-t overflow-y-auto rounded-bl">
      <div className="p-4 border-b space-y-2 sticky top-0 bg-white">
        <Search
          placeholder="Cari Resi"
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            debounceSearch(e.target.value);
          }}
        />
        <div className="flex space-x-2">
          <FilterButton
            menuClassName="w-full"
            onClick={() => {
              // trackEvent("Ticket FilterStatus");
            }}
            onResetFilters={() =>
              onChangeFilters("status", {
                active: {
                  ...props.filters.status.active,
                  selected: false,
                },
                processing: {
                  ...props.filters.status.processing,
                  selected: false,
                },
                solved: {
                  ...props.filters.status.solved,
                  selected: false,
                },
              })
            }
            activeFilter={
              Object.keys(props.filters.status).filter((i) => props.filters.status[i].selected)
                .length
            }
            buttonTitle="Filter Status"
            filterTitle="Status"
            filters={[
              {
                title: "Aktif",
                checked: props.filters.status.active.selected,
                onSelect: () =>
                  onChangeFilters("status", {
                    ...props.filters.status,
                    active: {
                      ...props.filters.status.active,
                      selected: !props.filters.status.active.selected,
                    },
                  }),
                count: props.filters.status.active.count,
              },
              {
                title: "Diproses",
                checked: props.filters.status.processing.selected,
                onSelect: () =>
                  onChangeFilters("status", {
                    ...props.filters.status,
                    processing: {
                      ...props.filters.status.processing,
                      selected: !props.filters.status.processing.selected,
                    },
                  }),
                count: props.filters.status.processing.count,
              },
              {
                title: "Selesai",
                checked: props.filters.status.solved.selected,
                onSelect: () =>
                  onChangeFilters("status", {
                    ...props.filters.status,
                    solved: {
                      ...props.filters.status.solved,
                      selected: !props.filters.status.solved.selected,
                    },
                  }),
                count: props.filters.status.solved.count,
              },
            ]}
          />
          <FilterButton
            onClick={() => {
              // trackEvent("Ticket FilterProblem");
            }}
            onResetFilters={() =>
              onChangeFilters("type", {
                shipment: {
                  ...props.filters.type.shipment,
                  selected: false,
                },
                cashOnDelivery: {
                  ...props.filters.type.cashOnDelivery,
                  selected: false,
                },
                retur: {
                  ...props.filters.type.retur,
                  selected: false,
                },
                claim: {
                  ...props.filters.type.claim,
                  selected: false,
                },
              })
            }
            menuClassName="w-auto"
            dropdownOrientation="right"
            activeFilter={
              Object.keys(props.filters.type).filter((i) => props.filters.type[i].selected).length
            }
            buttonTitle="Filter Kendala"
            filterTitle="Kategori Kendala"
            filters={[
              {
                title: "Penjemputan / Pengiriman",
                checked: props.filters.type.shipment.selected,
                onSelect: () =>
                  onChangeFilters("type", {
                    ...props.filters.type,
                    shipment: {
                      ...props.filters.type.shipment,
                      selected: !props.filters.type.shipment.selected,
                    },
                  }),
                count: props.filters.type.shipment.count,
              },
              {
                title: "Cash On Delivery (COD)",
                checked: props.filters.type.cashOnDelivery.selected,
                onSelect: () =>
                  onChangeFilters("type", {
                    ...props.filters.type,
                    cashOnDelivery: {
                      ...props.filters.type.cashOnDelivery,
                      selected: !props.filters.type.cashOnDelivery.selected,
                    },
                  }),
                count: props.filters.type.cashOnDelivery.count,
              },
              {
                title: "Retur",
                checked: props.filters.type.retur.selected,
                onSelect: () =>
                  onChangeFilters("type", {
                    ...props.filters.type,
                    retur: {
                      ...props.filters.type.retur,
                      selected: !props.filters.type.retur.selected,
                    },
                  }),
                count: props.filters.type.retur.count,
              },
              {
                title: "Klaim Paket Hilang / Rusak",
                checked: props.filters.type.claim.selected,
                onSelect: () =>
                  onChangeFilters("type", {
                    ...props.filters.type,
                    claim: {
                      ...props.filters.type.claim,
                      selected: !props.filters.type.claim.selected,
                    },
                  }),
                count: props.filters.type.claim.count,
              },
            ]}
          />
        </div>
        <div>
          <FilterDate
            isActive={props.filters.createdStartDate && props.filters.createdEndDate}
            onChangeDate={onChangeDate}
          />
        </div>
      </div>
      <div style={{ minHeight: props.windowHeight - (props.windowWidth < 768 ? 430 : 450) + "px" }}>
        {props.loading ? (
          <div className="flex justify-center pt-6">
            <ReactLoading type="spin" color={"#6E32BF"} height={36} width={36} />
          </div>
        ) : props.tickets && props.tickets.length > 0 ? (
          <TicketSection
            tickets={props.tickets}
            onClickTicket={props.onClickTicket}
            selectedTicket={props.selectedTicket}
            selectedTicketId={props.selectedTicketId}
          />
        ) : (
          <div className="flex justify-center text-gray-700 font-bold text-xs pt-4">
            Belum Ada tiket
          </div>
        )}
      </div>
      {/* <div className="sticky bottom-0 w-full p-4 md:py-6 border-t bg-white">
        <Button
          className="w-full justify-center"
          title={
            <div className="font-bold text-white flex items-center">
              <PlusCircleIcon className="w-4 h-4 flex-shrink-0" aria-hidden />
              <div className="ml-1">Buat Tiket Baru</div>
            </div>
          }
          onClick={() => {
            // trackEvent("Ticket CreateNewTicket");
            props.setOpenModal(true);
          }}
        />
      </div> */}
    </div>
  );
}
